module.exports = __webpack_public_path__ + "static/fonts/OpenSans-Regular.3ed9575.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/OpenSans-Regular.ttf
// module id = 8n3Y
// module chunks = 2